import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import * as Sentry from '@sentry/react';
import { router } from './router';
import { clientEnv, reportMissingClientEnv } from './lib/env';
import '@/styles/global.css';

if (clientEnv.sentryDsn) {
  Sentry.init({
    dsn: clientEnv.sentryDsn,
    environment: clientEnv.sentryEnvironment,
    release: clientEnv.release || undefined,
    sendDefaultPii: false,
  });
}
reportMissingClientEnv('shared');

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <main className="grid min-h-screen place-items-center bg-[#F3FBF0] p-6 text-center">
          <div>
            <h1 className="text-2xl font-bold">Hmonglus hit an unexpected problem.</h1>
            <p className="mt-2 text-slate-600">Refresh the page to try again.</p>
          </div>
        </main>
      }
    >
      <RouterProvider router={router} />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
